import Vue from 'vue'
import VueYoutube from 'vue-youtube'
import GTMVue from 'gtm-vue';
import router from './routes'
import store from './store'

import App from './App.vue'
import i18n from './i18n'
import { fallback_locale, fallback_theme, fallback_gtm } from './fallbacks'

Vue.config.productionTip = false

Vue.use(VueYoutube)

Vue.use(GTMVue, {
  id: fallback_gtm,
  router: router,
})

new Vue({
  render: h => h(App),
  router,
  store,
  data : {
    i18n,
    locale : process.env.VUE_APP_LOCALE || fallback_locale,
    theme : process.env.VUE_APP_THEME || fallback_theme,
  },
  created() {
    this.$store.commit('SET_THEME', this.theme)

    this.$store.commit('SET_LOCALE', this.theme == 'smartfit' ? this.locale : this.theme )
  },
  methods : {
    highlightLastWord (str) {
      const words = str.split(' ');
      const last_word = words[words.length - 1];
      words[words.length - 1] = null

      return `${words.join(' ')} <span>${last_word}<span>`;
    },
    returnToPreviousPage() {
      this.$router.go(-1)
      this.$gtm.trackEvent({
        event: 'gaEvent',
        eventCategory: `treine-em-casa-${this.theme}`,
        eventAction: 'voltar-ao-treino',
        eventLabel: ''
      })
    },
    getTitle(object) {
      if(!object.subtitle) {
          return object.title ? this.highlightLastWord(object.title) : ''
      }

      if(object.type === 'video-card') {
        return `${object.title} <span class="workout-video__title">${object.subtitle}<span>`;
      }

      return `${object.title} <span>${object.subtitle}<span>`;
    },
    t ( str ) {

      const { locale } = this.$store.state;
      return locale == 'br' || !this.i18n[locale] || !this.i18n[locale][str] ? str : this.i18n[locale][str];
    }
  },
}).$mount('#app')
